import { useHistory } from "react-router-dom";

interface NavigateOptions {
  replace?: boolean;
  state?: any;
}

type NavigateFunction = {
  (to: string, options?: NavigateOptions): void;
  (delta: number): void;
};

export function useNavigate(): NavigateFunction {
  const history = useHistory();

  return (to: string | number, options?: NavigateOptions) => {
    if (typeof to === "number") {
      history.go(to);
      return;
    }

    if (options && options.replace) {
      history.replace(to, options.state);
    } else {
      history.push(to, options?.state);
    }
  };
}
